export default __webpack_public_path__ + "static/media/Target_duotone_line.eaa87874.svg";